<ng-container [ngSwitch]="column.type">
  <div class="cell-color-icon" *ngSwitchCase="contentTypes.colorIcon"
       [style.background-color]="displayingContent"></div>
  <img class="cell-image" *ngSwitchCase="contentTypes.image" src="{{ content ? content : './assets/img/icons/plug.png' }}"/>
  <div class="cell-text" *ngSwitchDefault
       (click)='checkBubbling($event)'
       meeTableTooltip
       [tooltipText]="getTooltip(content)"
       [tooltipDisabled]="!showTooltip(content)"
       [innerHtml]="displayingContent | truncate:column.truncateLimit || 300 "
  ></div>

</ng-container>








